// src/components/Shared/BackButton.jsx
// Standardized in-app back button. Use on any page so users don't have to
// rely on the browser back gesture.
//
// Default: pops one history entry (navigate(-1)).
// `to`: pass a route to navigate to a specific destination instead.
// `fallback`: route to use if history is empty (e.g. user landed via direct URL).

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconArrowLeft } from './FigmaIcons';

const BackButton = ({ to, fallback = '/', label = 'Back', className = '' }) => {
	const navigate = useNavigate();
	const handleClick = (e) => {
		e.preventDefault();
		if (to) {
			navigate(to);
			return;
		}
		if (window.history.length > 1) {
			navigate(-1);
		} else {
			navigate(fallback);
		}
	};
	return (
		<button
			type="button"
			className={`ev-back-btn ${className}`.trim()}
			onClick={handleClick}
			aria-label={label}
		>
			<IconArrowLeft className="ev-icon-svg" />
			<span>{label}</span>
		</button>
	);
};

export default BackButton;
